import { RealtyObjectType, DealType } from '@search/filter-enums/enums';
import { ISelectOptionProps } from '@search/vtbeco-ui/src/components/controls/Select';
import { SortEnum, sortLabelMapping } from '@search/filter-enums/mappings/sort_label_mapping';
import {
    regionsEnumeration,
    regionsWithMetroEnumeration
} from '@search/filter-enums/enums/Region';
import { SortOffersType } from '@search/offer-search-routes/src/mappers/sortOffersMapper';

export function getSortValues({
    realtyType,
    dealType,
    regionId,
    sort
}: {
    realtyType: RealtyObjectType;
    dealType: DealType;
    regionId: number;
    sort: SortOffersType;
}) {
    const SORT_SELECT_VALUES: ISelectOptionProps[] = [
        {
            value: SortEnum.UNKNOWN,
            label: 'По умолчанию'
        },
        {
            value: SortEnum.PRICE,
            label: sortLabelMapping.price
        },
        {
            value: SortEnum.PRICE_DESC,
            label: sortLabelMapping.price_desc
        },
        {
            value: SortEnum.DATE,
            label: sortLabelMapping.date
        },
        {
            value: SortEnum.DISTANCE_TO_CITY_CENTER,
            label: sortLabelMapping.distanceToCityCenter
        },
        {
            value: SortEnum.TIME_TO_METRO,
            label: sortLabelMapping.timeToMetro
        },
        ...(dealType === DealType.SELL ?
            [
                {
                    value: SortEnum.PRICE_SQ_METER,
                    label: realtyType === RealtyObjectType.LAND ?
                        'Сначала дешевле за сотку' :
                        sortLabelMapping.priceSqMeter
                },
                {
                    value: SortEnum.PRICE_SQ_METER_DESC,
                    label: realtyType === RealtyObjectType.LAND ?
                        'Сначала дороже за сотку' :
                        sortLabelMapping.priceSqMeter_desc
                }
            ] : []
        ),
        {
            value: SortEnum.TOTAL_AREA_DESC,
            label: sortLabelMapping.totalArea_desc
        },
        {
            value: SortEnum.TOTAL_AREA,
            label: sortLabelMapping.totalArea
        },
        ...(sort === 'updateDate_desc' ? [ {
            value: SortEnum.UPDATE_DATE_DESC,
            label: sortLabelMapping.updateDate_desc
        } ] : []),
        // for backward compatibility
        // TODO remove 'updateDate' after few months
        ...(sort === 'updateDate' ? [ {
            value: SortEnum.UPDATE_DATE,
            label: sortLabelMapping.updateDate
        } ] : []),
    ];

    const hasMetro = regionsWithMetroEnumeration.has(regionId);
    const hasDistanceToCenter = regionsEnumeration.has(regionId);

    if (! hasMetro && ! hasDistanceToCenter) {
        return SORT_SELECT_VALUES.filter(selected => (selected.value !== SortEnum.DISTANCE_TO_CITY_CENTER &&
            selected.value !== SortEnum.TIME_TO_METRO));
    }

    if (! hasMetro && hasDistanceToCenter) {
        return SORT_SELECT_VALUES.filter(selected => selected.value !== SortEnum.TIME_TO_METRO);
    }

    if (hasMetro && ! hasDistanceToCenter) {
        return SORT_SELECT_VALUES.filter(selected => selected.value !== SortEnum.DISTANCE_TO_CITY_CENTER);
    }

    return SORT_SELECT_VALUES;
}
